<div class="gt-routes-list-containerss">
  <p class="manual-delete-hint" *ngIf="showManualDeleteHint" i18n="@@deleteBackupsManuallyHint">
    Select the backups you want to delete in the table, then click "Delete Database".
  </p>

  <dx-data-grid #exportsGrid [dataSource]="dbExports" class="gt-data-grid-style export-grid" [showRowLines]="true"
    [showBorders]="true" [allowColumnResizing]="true" [columnResizingMode]="'widget'" [columnAutoWidth]="false"
    [showBorders]="true" [scrolling]="{ mode: 'standard', useNative: true }" [width]="'100%'" class="gt-data-grid-style"
    [rowAlternationEnabled]="true" [hoverStateEnabled]="true" [(selectedRowKeys)]="selectedRows" keyExpr="id">
    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-selection mode="multiple" showCheckBoxesMode="always" [allowSelectAll]="false"></dxo-selection>

    <dxo-toolbar>
      <dxi-item width="50%" name="searchPanel" location="before"></dxi-item>
      <dxi-item width="50%">
        <div class="gt-flex-dir-row" style="gap: 8px">
          <app-gpd-button *ngIf="selectedRows.length > 0" type="danger-outline" icon="delete"
            i18n-text="@@deleteDatabase" text="Delete Database" (onClick)="deleteDatabase()">
          </app-gpd-button>
          <app-gpd-button icon="upload" [disabled]="exportInProgress" i18n-text="@@exportDatabase"
            text="Export Database" (onClick)="exportDatabase()">
          </app-gpd-button>
        </div>
      </dxi-item>
    </dxo-toolbar>

    <dxi-column dataField="createdDate" i18n-caption="@@createdDate" caption="Created Date" alignment="left"
      format="dd.MM.yyyy HH:mm" dataType="date"></dxi-column>

    <dxi-column dataField="status" i18n-caption="@@status" caption="Status" alignment="left"
      cellTemplate="statusCellTemplate">
      <div *dxTemplate="let item of 'statusCellTemplate'">
        <app-status-pill [statusId]="item.value ?? 2" [statusConfig]="exportConfigs"></app-status-pill>
      </div>
    </dxi-column>


    <dxi-column dataField="" allowEditing="false" cellTemplate="buttonCellTemplate" [width]="34"
      [formItem]="{ visible: false }">
      <div *dxTemplate="let item of 'buttonCellTemplate'">
        <app-svg-icon *ngIf="item.data.status == 0" class="download-action" icon="download"
          color="var(--color-primary)" [size]="20" [strokeWidth]="1.5" role="button" tabindex="0"
          i18n-title="@@download" title="Download" (click)="downloadExport(item.data)"
          (keydown.enter)="downloadExport(item.data)"></app-svg-icon>
      </div>
    </dxi-column>
  </dx-data-grid>
</div>

<app-delete-popup [visible]="popup" [message]="$safeNavigationMigration(popup?.message)" (onAbort)="popup?.onAbort; popup = null"
  (onConfirm)="popup?.onConfirm(); popup = null"></app-delete-popup>

<!-- <dx-toast [(visible)]="toastVisible" i18n-message="@@successfullySaved" message="Successfully saved"></dx-toast> -->